import styled from 'styled-components'

export const Body = styled('div')`
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: 'center';
  flex-direction: column;
  text-align: center;

`

export const Title = styled.h2`
  text-align: center;
  font-size: 1.8em;
`

export const Text = styled.p`
  font-size: 1.2em;
`
